if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaId = this.openedBy.getAttribute('data-media-id');
        const activeSlide = this.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeSlide) return;

        const sliderComponent = this.querySelector('slider-component');
        if (sliderComponent && sliderComponent.slider) {
          sliderComponent.slider.scrollLeft = activeSlide.offsetLeft;
          sliderComponent.update();
        }

        const deferredMedia = activeSlide.querySelector('deferred-media');
        const activeMediaTemplate = deferredMedia ? deferredMedia.querySelector('template') : null;
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        if (deferredMedia && activeMediaContent && activeMediaContent.querySelector('.js-youtube')) {
          deferredMedia.loadContent();
        }
      }
    }
  );
}
